import { useQueries } from 'react-query';


export const GRAPH_FIELDS = [
  'heaterGraphData',
  'enclosureGraphData',
  'outsideGraphData',
  'gasGraphData',
  'snowGraphData',
  'windGraphData',
];


export const graphQueryKey = (machine, field) => ['graph', machine, field];


export const useRealtimeGraphData = (swtName, location, machine) => {
  const results = useQueries(
    GRAPH_FIELDS.map((field) => ({
      queryKey: graphQueryKey(machine, field),
      queryFn: () => [],
      enabled: false,
      staleTime: Infinity,
    }))
  );

  return GRAPH_FIELDS.reduce((acc, field, i) => {
    acc[field] = results[i].data ?? [];
    return acc;
  }, {});
};
